/**
 * @author      carlos.soto@zumper.com (Carlos J. Soto)
 * @copyright   Copyright (c) 2024, Zumper
 * @description userMenuClickTrackers
 */

import { USER_MENU_CLICK, event } from '@zcode-ui/web-zumper-integrations'
import { EVENT_NAMES, PROP_NAMES, type Payload, track } from '@zcode/mixpanel'
import type { Dispatch } from '@zcode/nr/es/shared/types'

export const trackUserMenuClick =
  (linkClicked: string, pageName?: string) => (dispatch: Dispatch) => {
    const traktorPayload = {
      name: USER_MENU_CLICK,
      props: {
        linkClicked,
        pageName,
      },
    }

    const payload: Payload = {
      [PROP_NAMES.LINK_CLICKED]: linkClicked,
      [PROP_NAMES.PAGE_NAME]: pageName,
    }

    // traktor
    dispatch(event(traktorPayload))
    // mixpanel
    track({
      event: EVENT_NAMES.CLICK,
      payload,
    })
  }
